import { render, staticRenderFns } from "./RecentStatement.vue?vue&type=template&id=25a740a4&"
import script from "./RecentStatement.vue?vue&type=script&lang=js&"
export * from "./RecentStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports